import styled from "styled-components"

import { DoughnutChart } from "components/common/DoughnutChart"
import { type ChartOptions, RainbowChart } from "components/common/RainbowChart"

const SKELETON_LIGHT = "#E2E8F0"
const SKELETON_MAIN = "#CBD5E1"

const GaugeWrapper = styled.div`
  width: 240px;
  height: 195px;
  overflow: hidden;
`

const DoughnutWrapper = styled.div`
  width: 210px;
`

export const GaugeSkeleton = ({ options }: { options?: ChartOptions }) => (
  <GaugeWrapper>
    <RainbowChart values={[35, 65]} colors={[SKELETON_LIGHT, SKELETON_MAIN]} options={options} />
  </GaugeWrapper>
)

export const DoughnutSkeleton = () => (
  <DoughnutWrapper>
    <DoughnutChart values={[75, 25]} colors={[SKELETON_LIGHT, SKELETON_MAIN]} showTooltip={false} />
  </DoughnutWrapper>
)
